export const Spinner = ({ text, full = true }) => {
  return (
    <div
      className={`d-flex align-items-center justify-content-center flex-column ${
        full ? " h-100" : ""
      }`}
    >
      <div className="spinner-border text-success" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
      <p className="text-secondary mt-3">{text}</p>
    </div>
  );
};
